// ============================================================
// i18n.js — Gestor Centralizado de Internacionalización de Vimo
// ============================================================
import { translations, getTranslation } from './translations.js';

const LANG_KEY = 'vimo:lang';
const FLAG_URLS = {
  es: 'https://flagcdn.com/w20/es.png',
  en: 'https://flagcdn.com/w20/gb.png',
  pt: 'https://flagcdn.com/w20/br.png'
};

export function getCurrentLang() {
  return localStorage.getItem(LANG_KEY) || 'es';
}

export function applyCurrentTranslations() {
  const lang = getCurrentLang();
  const dict = translations[lang] || translations.es;

  // 1. Elementos con texto HTML/plano
  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.getAttribute('data-i18n');
    if (dict[key]) {
      if (dict[key].includes('<')) {
        el.innerHTML = dict[key];
      } else {
        el.textContent = dict[key];
      }
    }
  });

  // 2. Placeholders de inputs y textareas
  document.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
    const key = el.getAttribute('data-i18n-placeholder');
    if (dict[key]) {
      el.setAttribute('placeholder', dict[key]);
    }
  });

  // 3. Atributos aria-label y title para accesibilidad
  document.querySelectorAll('[data-i18n-aria-label]').forEach((el) => {
    const key = el.getAttribute('data-i18n-aria-label');
    if (dict[key]) {
      el.setAttribute('aria-label', dict[key]);
    }
  });

  document.querySelectorAll('[data-i18n-title]').forEach((el) => {
    const key = el.getAttribute('data-i18n-title');
    if (dict[key]) {
      el.setAttribute('title', dict[key]);
    }
  });

  // 4. Actualizar estado visual de selectores de idioma en el DOM
  document.querySelectorAll('.lang-current').forEach((lc) => {
    lc.innerHTML = `<img src="${FLAG_URLS[lang] || FLAG_URLS.es}" width="20" alt="${lang.toUpperCase()}" style="border-radius:2px; vertical-align: middle;">`;
  });

  document.querySelectorAll('.lang-option').forEach((opt) => {
    if (opt.dataset.lang === lang) {
      opt.classList.add('is-active');
    } else {
      opt.classList.remove('is-active');
    }
  });

  // 5. Emitir evento global para vistas con componentes dinámicos
  window.dispatchEvent(new CustomEvent('vimo:language-change', { detail: { lang, dict } }));
}

export function setAppLanguage(lang) {
  if (!translations[lang]) lang = 'es';
  localStorage.setItem(LANG_KEY, lang);
  applyCurrentTranslations();
}

export function initI18n() {
  // Aplicar traducciones iniciales de inmediato
  applyCurrentTranslations();

  // Escuchar clics en cualquier selector de idioma presente en la página
  document.querySelectorAll('.lang-selector').forEach((selector) => {
    const btn = selector.querySelector('#langDropdownBtn') || selector.querySelector('.lang-btn');
    if (btn && !btn._hasI18nListener) {
      btn._hasI18nListener = true;
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        selector.classList.toggle('is-open');
      });
    }

    selector.querySelectorAll('.lang-option').forEach((opt) => {
      if (!opt._hasI18nListener) {
        opt._hasI18nListener = true;
        opt.addEventListener('click', () => {
          const lang = opt.dataset.lang;
          setAppLanguage(lang);
          selector.classList.remove('is-open');
        });
      }
    });
  });

  // Cerrar desplegables de idioma al hacer clic fuera
  document.addEventListener('click', (e) => {
    document.querySelectorAll('.lang-selector.is-open').forEach((sel) => {
      if (!sel.contains(e.target)) {
        sel.classList.remove('is-open');
      }
    });
  });
}
